<template>
  <div />
</template>

<script lang="ts">
import { defineComponent, onMounted, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useUserStore } from '@/store/modules/user'
import appEnv from '@/support/env'

export default defineComponent({
  name: 'WidgetScript',
  setup() {
    const userStore = useUserStore()
    const { widgetEnabled, widgetData, isStaff } = storeToRefs(userStore)
    const domain = appEnv.WIDGET_DOMAIN
    const key = appEnv.WIDGET_KEY

    const buildScript = () => {
      const urlParams = new URLSearchParams(window.location.search)
      const code = `
        (function(d,t) {
          var g=d.createElement(t),s=d.getElementsByTagName(t)[0];
          g.src='https://${domain}/embed.js'
          s.parentNode.insertBefore(g,s);
          g.onload=function(){
            console.log('start widget')
            window.widget = new window.ChaskiqMessengerEncrypted({
              domain: "https://${domain}",
              ws:  "wss://${domain}/cable",
              app_id: '${key}',
              data: ${widgetData.value},
              lang: "en",
              open: ${urlParams.has('open_widget')}
            })
            window.dispatchEvent(new CustomEvent('widget-ready'));
          }
        })(document,"script");
      `
      window.addEventListener(
        'widget-ready',
        () => {
          userStore.isWidgetScriptLoaded = true
        },
        { once: true }
      )

      setTimeout(() => {
        console.log('init widget')
        const script = document.createElement('script')
        script.text = code
        document.head.appendChild(script)
      })
    }

    onMounted(() => {
      if (widgetEnabled.value && domain && key && !isStaff.value) {
        buildScript()
      }
    })

    watch(widgetEnabled, (newValue: any) => {
      if (newValue && domain && key && !isStaff.value) {
        buildScript()
      }
    })
  }
})
</script>
